/**
 * Static application identity. In the multi-tenant model the visual branding
 * (colours, logo, icons) is served per-tenant by the backend, but the textual
 * app name and description are intentionally static across all tenants.
 */
export const APP_NAME = "Participants App";

export const APP_DESCRIPTION =
  "Get your clinical trial expenses paid, quickly, easily and securely, in a way most convenient for you.";
